import { render, staticRenderFns } from "./InstallationForm.vue?vue&type=template&id=f014d130&scoped=true"
import script from "./InstallationForm.ts?vue&type=script&lang=ts&external"
export * from "./InstallationForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f014d130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f014d130')) {
      api.createRecord('f014d130', component.options)
    } else {
      api.reload('f014d130', component.options)
    }
    module.hot.accept("./InstallationForm.vue?vue&type=template&id=f014d130&scoped=true", function () {
      api.rerender('f014d130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/InstallationForm/InstallationForm.vue"
export default component.exports